import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

// Toggle Bookmark
export const toggleBookmark = createAsyncThunk(
  "bookmark/toggle",
  async (postId, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.patch(
        `${API_URL}/bookmark/${postId}`,
        {},
        { headers: { Authorization: `${token}` } },
      );

      return postId;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Get My Bookmarks
export const getMyBookmarks = createAsyncThunk(
  "bookmark/getMy",
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const params = {
        page,
        limit,
      };
      // const res = await axios.get(`${API_URL}/bookmark`, params, {
      //   headers: { Authorization: `${token}` },
      // });
      const res = await axios.get(`${API_URL}/bookmark`, {
        params,
        headers: { Authorization: `${token}` },
      });
      // console.log(res);
      return res.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
